import React from 'react';
import { Box, Typography, IconButton } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useNavigate } from 'react-router-dom';
import { theme } from '../../utils/interview/theme';
import { getTranslation } from '../../utils/interview/i18n';

function ChatHeader({ language = 'en' }) {
  const navigate = useNavigate();

  const handleBack = () => {
    navigate('/');
  };

  return (
    <Box
      sx={{
        p: 3,
        textAlign: 'center',
        borderBottom: `1px solid ${theme.colors.border}`,
        flexShrink: 0,
        background: theme.gradients.header,
        color: 'white',
        position: 'relative',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <IconButton
        onClick={handleBack}
        sx={{
          position: 'absolute',
          left: 16,
          color: 'white',
          '&:hover': {
            backgroundColor: 'rgba(255, 255, 255, 0.1)',
          },
        }}
        aria-label="Go back to home"
      >
        <ArrowBackIcon />
      </IconButton>
      <Box sx={{ flex: 1 }}>
        <Typography
          variant="h4"
          sx={{
            fontFamily: '"museo-sans", sans-serif',
            fontWeight: 700,
            letterSpacing: '0.5px',
            mb: 0.5,
          }}
        >
          {getTranslation('williamAI', language)}
        </Typography>
        <Typography
          variant="caption"
          sx={{
            display: 'block',
            opacity: 0.95,
            fontSize: '0.85rem',
            fontWeight: 400,
          }}
        >
          {getTranslation('virtualInterviewer', language)}
        </Typography>
      </Box>
    </Box>
  );
}

export default ChatHeader;


